@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.container {
  display: flex;
  flex-direction: column;

  .separator {
    @include separator-bottom;
  }

  .headline {
    color: $grey-text;
    font-size: 2rem;
    line-height: 2rem;
    font-weight: 300;
    margin-top: 2.125rem;
    margin-bottom: 0.75rem;
    text-transform: uppercase;

    @include mobile {
      font-size: 1.25rem;
      line-height: 1.5rem;
      margin-top: 1.78125rem;
      margin-bottom: 0.25rem;

    }
  }
}